import { set } from "tiny-cookie";

export type SetCookieFn = (...input: Parameters<typeof set>) => ReturnType<typeof set>;

type Newsletter = "newsletter";
type Marktfoschung = "marktforschung";
export type LayerType = Newsletter | Marktfoschung;

export default class LayerCounterLogic {
    private readonly setCookieFn: SetCookieFn;
    private readonly location: Location;

    constructor(setCookieFn: SetCookieFn, location: Location) {
        this.setCookieFn = setCookieFn;
        this.location = location;
    }

    determineLayerState(counter: number, layerType: LayerType): void {
        if (/\?newsletter=/.test(this.location.search)) {
            this.setCookieFn("entd_newsletter_layer", "noshow", {
                expires: 1000000,
                domain: this.location.hostname,
                path: "/",
            });

            this.setCookieFn("entd_mafo_counter", "5", {
                domain: this.location.hostname,
                path: "/",
            });
        } else {
            if (layerType === "newsletter") {
                this.setCookieFn("entd_newsletter_counter", counter.toString(), {
                    domain: this.location.hostname,
                    path: "/",
                    // Has to be a session cookie to determine seenNewsletterInCurrentSession in com/breuninger/entdecken/domain/model/LayerState.scala
                });
            } else {
                this.setCookieFn("entd_mafo_counter", counter.toString(), {
                    domain: this.location.hostname,
                    path: "/",
                    // Has to be a session cookie to determine seenNewsletterInCurrentSession in com/breuninger/entdecken/domain/model/LayerState.scala
                });

                this.setCookieFn("entd_newsletter_layer", "noshow", {
                    expires: 1000000,
                    domain: this.location.hostname,
                    path: "/",
                });
            }
        }
    }
}
